import type { DayOfWeek } from "@smartsuite/automation-engine-api";
import i18n from "i18next";
import { observer } from "mobx-react-lite";
import type { FC } from "react";
import { useEffect, useState } from "react";
import { useRootStore } from "../../../../../../../../../../stores/hooks";
import { getLocaleByLangCode } from "../../../../../../../../../../utils/locale";
import { useRepeatedSchedule } from "../../repeated-schedule.hook";
import * as S from "./style";
import type { WeekDayNumbers } from "@smartsuite/react-ui/lib";
import { WeekDayPicker } from "@smartsuite/react-ui/lib";

export const WeekDay: FC = observer(() => {
  const [value, setValue] = useState<WeekDayNumbers[]>([]);

  const { scheduleStore } = useRootStore();
  const { getDaysOfWeek, setDaysOfWeek } = useRepeatedSchedule();

  useEffect(() => {
    setValue(daysToWeekDayNumbers(getDaysOfWeek()));
  }, [scheduleStore.schedule]);

  return (
    <>
      <S.Pipe />
      <S.Wrapper>
        <WeekDayPicker
          locale={getLocaleByLangCode(i18n.language)}
          firstDayOfWeek={1}
          className="weekday-text"
          selected={value}
          onChange={(selected: WeekDayNumbers[]) =>
            setDaysOfWeek(weekDayNumbersToDays(selected))
          }
        />
      </S.Wrapper>
      <S.Pipe />
    </>
  );
});

const daysToWeekDayNumbers = (days: DayOfWeek[]): WeekDayNumbers[] =>
  days.map((day) => (day === 7 ? 0 : day));

const weekDayNumbersToDays = (days: WeekDayNumbers[]): DayOfWeek[] =>
  days.map((day) => (day === 0 ? 7 : day));
